(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sh-premium-hero"] && !Shopify.designMode) return;
  try {
    
  class ShPremiumCarousel {
    constructor(el) {
      this.el = el;
      this.currentIndex = 0;
      this.gap = parseInt(el.dataset.gap, 10) || 20;
      this.track = el.querySelector('[data-carousel-track]');
      this.prevBtn = el.querySelector('[data-carousel-prev]');
      this.nextBtn = el.querySelector('[data-carousel-next]');
      this.items = el.querySelectorAll('.sh-premium-hero__carousel-item');

      if (!this.track || this.items.length === 0) return;

      this.updateItemsPerView();
      this.bindEvents();
      this.updateButtons();
    }

    get itemsPerView() {
      const w = window.innerWidth;
      if (w <= 749) return 2;
      if (w <= 989) return 2;
      return 4;
    }

    updateItemsPerView() {
      this._itemsPerView = this.itemsPerView;
    }

    maxIndex() {
      return Math.max(0, this.items.length - this._itemsPerView);
    }

    bindEvents() {
      this.prevBtn.addEventListener('click', () => this.prev());
      this.nextBtn.addEventListener('click', () => this.next());

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.updateItemsPerView();
          if (this.currentIndex > this.maxIndex()) {
            this.currentIndex = this.maxIndex();
          }
          this.slide();
        }, 100);
      });

      /* Touch / swipe */
      let startX = 0, currentX = 0, dragging = false;
      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        dragging = true;
      }, { passive: true });
      this.track.addEventListener('touchmove', (e) => {
        if (dragging) currentX = e.touches[0].clientX;
      }, { passive: true });
      this.track.addEventListener('touchend', () => {
        if (!dragging) return;
        const diff = startX - currentX;
        if (Math.abs(diff) > 50) diff > 0 ? this.next() : this.prev();
        dragging = false;
      });
    }

    prev() {
      if (this.currentIndex > 0) { this.currentIndex--; this.slide(); }
    }

    next() {
      if (this.currentIndex < this.maxIndex()) { this.currentIndex++; this.slide(); }
    }

    slide() {
      const itemWidth = this.items[0].offsetWidth;
      const offset = -(this.currentIndex * (itemWidth + this.gap));
      this.track.style.transform = 'translateX(' + offset + 'px)';
      this.updateButtons();
    }

    updateButtons() {
      this.prevBtn.disabled = this.currentIndex === 0;
      this.nextBtn.disabled = this.currentIndex >= this.maxIndex();
    }
  }

  /* Init all instances on the page */
  document.querySelectorAll('[data-sh-carousel]').forEach(function(el) {
    new ShPremiumCarousel(el);
  });

  } catch(e) { console.error(e); }
})();
})();
